export default __webpack_public_path__ + "static/media/motor1.e5e124b8.jpg";